import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { BasketCheckoutButtonModel } from 'autogen/swagger/all';
import { ContinueShopping } from 'autogen/translation-keys/trans-website-basket';
import { Button } from 'components/Button';
import Flex from 'components/Layout/components/Flex';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { useTranslation } from 'react-i18next';
import BasketCheckoutButton from './BasketCheckoutButton';
import usePointOfSaleRequest from 'hooks/user/usePointOfSaleRequest';

const StyledButton = styled(Button)`
    flex: 1;
    white-space: nowrap;
`;

const ActionContainer = styled(Flex.Row)`
    min-width: auto;
    ${breakpoint.up(sizes.sm)} {
        min-width: 50%;
    }
`;

export default function CheckoutActions({ model }: { model: BasketCheckoutButtonModel }) {
    const { t } = useTranslation();
    const { isPosRequest } = usePointOfSaleRequest();

    return (
        <ActionContainer gap={Spacing8}>
            {!isPosRequest && (
                <StyledButton forwardedAs="a" href="/" size="lg" variant="secondary">
                    {t(ContinueShopping)}
                </StyledButton>
            )}

            <BasketCheckoutButton model={model} />
        </ActionContainer>
    );
}
